import { PostulacionAccionLog } from '../services/postulaciones-log.service';

export const POSTULACIONES_LOG_MOCK: PostulacionAccionLog[] = [
  {
    timestamp: '2026-05-25T16:40:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1001',
    folio: '500001',
    accion: 'crear_postulacion',
    detalle: 'Crea la postulacion y deja el concurso en estado en preparacion.',
  },
  {
    timestamp: '2026-05-25T17:25:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1001',
    folio: '500001',
    accion: 'editar_formulario',
    detalle: 'Actualiza antecedentes del proyecto y presupuesto.',
  },
  {
    timestamp: '2026-05-25T17:40:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1001',
    folio: '500001',
    accion: 'solicitar_patrocinio',
    detalle: 'Solicita patrocinio institucional para la postulacion.',
  },
  {
    timestamp: '2026-05-25T18:10:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1006',
    folio: '500055',
    accion: 'invitar_colaborador',
    detalle: 'Invita un integrante para completar el equipo de trabajo.',
  },
  {
    timestamp: '2026-05-25T18:28:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1006',
    folio: '500055',
    accion: 'invitar_recomendador',
    detalle: 'Invita un recomendador para apoyar la postulacion.',
  },
  {
    timestamp: '2026-05-25T19:05:00',
    usuario: 'Maria Fernandez',
    rol: 'recomendador',
    idPostulacion: 'P-1006',
    folio: '500055',
    accion: 'guardar_recomendacion',
    detalle: 'Guarda un borrador de la recomendacion solicitada.',
  },
  {
    timestamp: '2026-05-25T19:55:00',
    usuario: 'Jorge Silva',
    rol: 'representante_institucional',
    idPostulacion: 'P-1011',
    folio: '500103',
    accion: 'solo_lectura',
    detalle: 'Accede al formulario en modo lectura para revisar observaciones.',
  },
  {
    timestamp: '2026-05-25T20:15:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1011',
    folio: '500103',
    accion: 'editar_formulario',
    detalle: 'Corrige la postulacion observada y actualiza documentos.',
  },
  {
    timestamp: '2026-05-25T21:05:00',
    usuario: 'Camilo Garcia',
    rol: 'postulante',
    idPostulacion: 'P-1003',
    folio: '500012',
    accion: 'enviar_postulacion',
    detalle: 'Envia la postulacion completa para evaluacion.',
  },
  {
    timestamp: '2026-05-25T21:25:00',
    usuario: 'Jorge Silva',
    rol: 'representante_institucional',
    idPostulacion: 'P-1001',
    folio: '500001',
    accion: 'firmar_patrocinio',
    detalle: 'Firma de patrocinio registrada correctamente.',
  },
];
